<template>
  <v-layout justify-center>
    <v-flex>
      <v-carousel cycle hide-delimiter-background show-arrows-on-hover height="380">
        <v-carousel-item hide-delimiter-background v-for="(item, i) in items" :key="i" :src="item.src">
          <v-row class="fill-height" align="center">
            <v-card-text align="left">
              <div class="ml-15 text-h3 font-weight-bold white--text shadow-grey">{{ slides[i] }}</div>
              <div class="ml-15 text-h5 font-weight-regular primary--text">{{ slides2[i] }}</div>
            </v-card-text>
          </v-row>
        </v-carousel-item>
      </v-carousel>
      <v-container>
        <v-row align="center" justify="center" class="mt-5">
          <v-col cols="12">
            <!-- presentacion -->
            <v-card-title class="text-h3 font-weight-bold justify-center primary--text">Facturación electrónica sin
              límite</v-card-title>
            <v-card-title class="text-h4 font-weight-regular justify-center grey--text">Muy facil de usar</v-card-title>
          </v-col>
        </v-row>
      </v-container>
      <v-item-group class="mt-10 mb-10">
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5" sm="5" align="center">
              <!-- Servicio 1 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/boxes.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Sistema de Ventas con Inventario</v-card-title>
                <v-card-text class="text-h7 font-weight-regular text-left grey--text">
                  Impulsa tu negocio con una solución ágil y moderna:
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon>Ventas rápidas con interfaz intuitiva para atención
                  al cliente
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Control de stock en tiempo real
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Facturación electrónica SUNAT integrada
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Reportes detallados por producto, día, usuario y más
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Control de accesos por roles
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Ideal para tiendas, minimarkets, librerías,
                  ferreterías y más
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="5" sm="5" align="center">
              <!-- Servicio 2 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/heart.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Sistema para Farmacias</v-card-title>
                <v-card-text class="text-h7 font-weight-regular text-left grey--text">
                  Diseñado para la gestión integral de establecimientos farmacéuticos:
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Gestión de medicamentos con categorías,
                  presentaciones y stock mínimo
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Inventario por lotes y control de fechas de
                  vencimiento
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Facturación electrónica SUNAT integrada
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Reportes mensuales de ventas, productos más vendidos
                  y control de stock
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Alertas automáticas por vencimiento
                  <br />
                  <v-icon slot="icon" color="primary">done</v-icon> Ideal para boticas, droguerías y otros negocios del
                  rubro farmacéutico
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
      <v-item-group class="mt-10 mb-10">
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 1 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/imagen.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Personalida tu logo</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 2 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/house.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Establecimientos/Locales</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 3 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/email.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Envío por email</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
      <v-item-group class="mt-10 mb-10">
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 4 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/tiempo.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Activación con SUNAT</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 5 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/soporte.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Soporte</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 6 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/grafico.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Informe de ventas</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
      <v-item-group class="mt-10 mb-10">
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 4 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/stock.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Control de stock</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 5 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/seguridad.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Seguridad</v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center">
              <!-- Servicio 6 -->
              <v-card>
                <br />
                <v-img :src="require('../assets/web/contabilidad.png')" height="100px" width="100px"></v-img>
                <v-card-title class="text-h5 justify-center">Contabilidad</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../assets/web/slider.png"),
        },
        {
          src: require("../assets/web/slider2.png"),
        },
        {
          src: require("../assets/web/slider3.png"),
        },
      ],

      slides: [
        " EMITE FACTURAS Y BOLETAS",
        " EMPIEZA A CRECER",
        " ORDENA TU NEGOCIO",
      ],
      slides2: [
        " Software de Facturación Electronica",
        " y expande tu negocio",
        " Controla tu inventario",
      ],
    };
  },
};
</script>

<style>
.shadow-grey {
  text-shadow: 2px 2px 2px grey;
}
</style>